import { render, staticRenderFns } from "./lotteryNumberDF.vue?vue&type=template&id=cae05586"
import script from "./lotteryNumberDF.vue?vue&type=script&lang=js"
export * from "./lotteryNumberDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports